import { createListenerMiddleware, TypedStartListening } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "./form.store";

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;
